import React, {useState, useEffect} from "react";
import Profile from "./Profile";
import { LinearProgress,
    Theme,
    withStyles,
    createStyles,
    makeStyles, Button } from "@material-ui/core";
import {Link, useHistory, useLocation} from "react-router-dom";
import SquareLink from "./SquareLink";
import CommunicationPref from "./CommunicationPref";
import Container from "@material-ui/core/Container";

interface Props {
	isOnBoarding: boolean;
	setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
    step?: number;
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        marginBottom: "25px"
    },
    hidden: {
        display: "none"
    }
}));

const CustomLinearProgress = withStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
            left: "40px !important",
            top: "25px !important",
        },
        bar: {
            borderRadius: 5,
            backgroundColor: "primary",
        },
    }),
)(LinearProgress);

const UserOnBoarding = ({ isOnBoarding, setIsOnBoarding, step = 0 }: Props) => {
    const [count, setCount] = useState(step);
    const history = useHistory();

    const changeCount = (number: number) => {
        let newNumber = count + number;
        setCount(newNumber);
    };

    return(
        <>
            {count < 4 && count >= 0 &&
                <CustomLinearProgress variant="determinate" color="secondary" value={Math.round((count/3)*100)}/>
            }
            {count === 0 &&
                <Profile changeCount={changeCount}/>
            }
            {count === 1 &&
                <SquareLink changeCount={changeCount} />
            }
            {count === 2 &&
                <CommunicationPref changeCount={changeCount}/>
            }
            {count === 3 &&
                <Container style={{ paddingTop: "20px"}}>
                    <div>
                        <p>Congratulations Vettie!</p>
                        <p>To complete your onboarding please make a test appointment with the calendly link below to complete your training.</p>
                        Calendly link: <a href="https://calendly.com/felicity-johnson/15min" target="_blank" rel="noreferrer">Click!</a>
                        <p>We look forward to working with you!</p>
                        <Button variant="contained" color="secondary" onClick={() => {
                            localStorage.setItem("onboarded", true);
                            history.push("/")
                        }}>Finish</Button>
                    </div>
                </Container>
            }
        </>
    );
};

export default UserOnBoarding;
